<p-pickList
  [source]="hidedColumns"
  [target]="selectedColumns"
  [sourceHeader]="'Скрытые столбцы'"
  [targetHeader]="'Отображаемые столбцы'"
  [showSourceControls]="false"
  [showTargetControls]="false"
  [dragdrop]="true"
  [responsive]="true"
  filterBy="header"
  [sourceStyle]="{ height: '30rem' }"
  [targetStyle]="{ height: '30rem' }"
  breakpoint="1024px"
  (onMoveAllToSource)="onEmit()"
  (onMoveAllToTarget)="onEmit()"
  (onMoveToSource)="onEmit()"
  (onMoveToTarget)="onEmit()"
  (onTargetReorder)="onEmit()"
>
  <ng-template let-item pTemplate="item">
    <div>
      <span>{{ item.header }}</span>
    </div>
  </ng-template>
</p-pickList>
